<template>
  <v-card>
    <v-layout>
      <v-app-bar title="ONEPLAN Админка"></v-app-bar>

      <Navigation />

      <v-main style="min-height: calc(100vh - 100px)">
        <v-container fluid>
          <v-card>
            <v-card-title>Подкатегории</v-card-title>
            <v-card-text>
              <SubcategoriesList />
            </v-card-text>
          </v-card>
        </v-container>
      </v-main>
    </v-layout>
  </v-card>
</template>
<script>
import Navigation from "@/components/Navigation";
import SubcategoriesList from "@/components/Subcategories/SubcategoriesList.vue";
export default {
  components: {
    Navigation,
    SubcategoriesList
  },
};
</script>
